<p *ngIf="props.heading" class="mb-2">{{ props.heading }}</p>

<mat-form-field>
  <mat-label>
    {{ props.label }}
  </mat-label>
  <lui-form-field-indicator></lui-form-field-indicator>
  <mat-chip-grid
    class="d-block w-100"
    #chipGrid
    [formControl]="formControl"
    [required]="$any(props.required)"
  >
    <mat-chip-row
      *ngFor="let option of selection.selected"
      [value]="option"
      [removable]="!props.readonly"
      (removed)="selection.deselect(option)"
    >
      {{ option | matchingLabel : (props.options | castObservable | async) }}
      <button matChipRemove>
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </mat-chip-row>
    <input
      class="w-100"
      type="text"
      autocomplete="off"
      [formControl]="control"
      [placeholder]="$any(props.placeholder)"
      [matChipInputFor]="chipGrid"
      [matAutocomplete]="auto"
      #input
    />
  </mat-chip-grid>
  <mat-autocomplete
    [hideSingleSelectionIndicator]=""
    #auto="matAutocomplete"
    (optionSelected)="onOptionSelected($event.option.value)"
  >
    <ng-container *ngIf="props.options | formlySelectOptions as options">
      <mat-option
        *ngFor="
          let option of options | async | filterWith : input.value : 'label'
        "
        [value]="option.value"
        [disabled]="selection.isSelected(option.value)"
      >
        {{ option.label }}
      </mat-option>
    </ng-container>
  </mat-autocomplete>
  <mat-error>
    <formly-validation-message [field]="field"></formly-validation-message>
  </mat-error>
</mat-form-field>
